import api from '../../../services/api';
import buildQuery from 'odata-query'

export const TRAINING_USER_URL = '/traininguser'

// Pega todas as LPP
export function getAllTraining() {
    return api.get(TRAINING_USER_URL)
}

//
export function fetchTrainingByQuery (query) {
    return api.get(`/traininguser/odata/` + buildQuery(query));
}

export function updateTraining(training) {
    return api.put(`${TRAINING_USER_URL}`, training);
}

export function createTraining(training) {
    return api.post(`${TRAINING_USER_URL}`, training)
}


export function updateTrainingUser(training) {
    return api.put(`${TRAINING_USER_URL}`, training);
}

export function createTrainingUser(training) {
    return api.post(`${TRAINING_USER_URL}`, training)
}
